import config from "@/config";
import * as _ from "lodash-es";
import http from "@/utils/request";
import * as util from "@/utils";

export default {
  bugTitle: {
    get: function (projectNum) {
      const url = "/lqa-game/system/bugFiledConfig/titleConfig/list";
      return http.get(url, {projectNum});
    },
    update: function (data = []) {
      const url = "/lqa-game/system/bugFiledConfig/titleConfig/newBugTitle";
      return http.post(url, data);
    }
  },
  bugFiled: {
    // 字段列表
    getFiledList: function (projectNum, versionNum) {
      const url = "/lqa-game/system/bugFiledConfig/getBugTableFiled";
      return http.get(url, {projectNum, versionNum, configType: 2});
    },
    // 搜索条件列表
    getSearchFiledList: function (projectNum, versionNum) {
      const url = "/lqa-game/project/bugTable/config/getDefault";
      return http.get(url, {projectNum, versionNum, configType: 1});
    },
    // 更新搜索条件列表
    updateSearchFiledList: async function (list, projectNum) {
      const data = {searchDatas: list, projectNum, configType: 1};
      try {
        await http.post("/lqa-game/project/bugTable/config", data);
      } catch (e) {
        //
      }
    },
    // 表格条件列表
    getListFiledList: function (projectNum, versionNum) {
      const url = "/lqa-game/project/bugTable/config/getDefault";
      return http.get(url, {projectNum, versionNum, configType: 2});
    },
    // 表格搜索条件列表
    updateListFiledList: async function (list, projectNum) {
      const data = {cloumdDatas: list, projectNum, configType: 2};
      try {
        await http.post("/lqa-game/project/bugTable/config", data);
      } catch (e) {
        //
      }
    },
  },

  createTemplate: {
    url: `${config.API_URL}/lqa-game/project/bugTemplate`, name: "创建Bug模板", post: function (data) {
      return http.post(this.url, data);
    }
  }, templateList: {
    url: `${config.API_URL}/lqa-game/project/bugTemplate/getTemplateNames`,
    name: "获取模板列表",
    get: function (projectNum) {
      return http.get(this.url, {projectNum});
    }
  }, templateDetails: {
    url: `${config.API_URL}/lqa-game/project/bugTemplate/getBugTemplate`,
    name: "获取模板详情",
    get: function (templateId) {
      return http.get(this.url, {id: templateId});
    }
  }, getTpadUserName: {
    name: "获取TAPD用户信息", get: async function (keyword) {
      let res
      if (keyword && keyword.length > 0) {
        res = await http.get("/lqa-game/system/project/common/getTapdUserByName", {userName: keyword || ""});
      } else {
        res = await http.get("/lqa-game/system/project/common/getTapdDealUsers");
      }
      if (res) {
        const list = [];
        _.each(res.data || [], function (key, value) {
          list.push({dictValue: key, dictLabel: value});
        })
        return {code: 200, data: list};
      }
      return {code: 500, data: []};
    }
  }, workingList: {
    url: `${config.API_URL}/lqa-game/system/bugInfo/getAllProjects`, name: "进行中的项目列表", get: function (params) {
      return http.post(this.url, params);
    }
  }, list: {
    url: `${config.API_URL}/lqa-game/system/project/list`, name: "获取产品列表", get: function (params) {
      return http.get(this.url, params);
    }
  }, getAllUserInfoDict: {
    url: `${config.API_URL}/lqa-game/system/project/getMyPmName`, name: "获取所有用户字典列表", get: function () {
      return http.get(this.url);
    }
  }, checkRoles: {
    url: `${config.API_URL}/lqa-game/system/project/checkRole?projectNum=`, name: "检查权限", get: function (param) {
      return http.get(this.url + param);
    }
  }, checkProjectWords: {
    url: `${config.API_URL}/lqa-game/system/project/checkLanguage?projectNum=`,
    name: "检查语言包信息",
    get: function (param1, param2) {
      return http.get(this.url + param1 + '&lang=' + param2);
    }
  }, getMyProInfo: {
    url: `${config.API_URL}/lqa-game/system/project/myProList`, name: "获取产品列表", get: function () {
      return http.get(this.url);
    }
  }, getMyProjectVerInfo: {
    url: `${config.API_URL}/lqa-game/system/project/myProVerInfo`, name: "获取项目版本信息列表", get: function () {
      return http.get(this.url);
    }
  }, getProjectByNum: {
    url: `${config.API_URL}/lqa-game/system/project/getOneByNum?projectNum=`,
    name: "获取产品列表",
    get: function (param) {
      return http.get(this.url + param);
    }
  }, init: {
    url: `${config.API_URL}/lqa-game/system/project/initproject`, name: "获取产品列表", post: function () {
      return http.post(this.url);
    }
  }, getLastVersionInfo: {
    url: `${config.API_URL}/lqa-game/system/project/getMyProVersoin?projectNum=`,
    name: "获取项目的版本信息",
    get: function (param) {
      return http.get(this.url + param);
    }
  },

  exportProjectExcel: {
    url: `${config.API_URL}/lqa-game/system/project/export`, name: "获取所有任务看板信息", get: function (params) {
      return http.get(this.url, params);

    },
  }, post: {
    url: `${config.API_URL}/lqa-game/system/project`, name: "创建项目", post: function (data) {
      return http.post(this.url, data);
    }
  }, put: {
    url: `${config.API_URL}/lqa-game/system/project`, name: "修改项目", put: function (data) {
      return http.put(this.url, data);
    }
  }, addProUser: {
    url: `${config.API_URL}/lqa-game/system/projectuser`, name: "添加项目相关人员", post: function (data) {
      return http.post(this.url, data);
    }
  }, proUserList: {
    url: `${config.API_URL}/lqa-game/system/projectuser/list`, name: "获取相关人员列表", get: function (data) {
      return http.get(this.url, data);
    }
  }, proUserBugList: {
    url: `${config.API_URL}/lqa-game/system/projectuser/bugUserlist`, name: "获取相关人员列表", get: function (data) {
      return http.get(this.url, data);
    }
  }, getAllProPerson: {
    url: `${config.API_URL}/lqa-game/system/projectuser/allUserList`, name: "获取相关人员列表", get: function (data) {
      return http.get(this.url, data);
    }
  },

  deleteProUser: {
    url: `${config.API_URL}/lqa-game/system/projectuser/`, name: "获取相关人员列表", delete: function (param) {
      return http.delete(this.url + param);
    }
  }, //
  proUserDictList: {
    url: `${config.API_URL}/lqa-game/system/projectuser/getUserDict?versionNum=`,
    name: "获取相关人员列表",
    get: function (param) {
      return http.get(this.url + param);
    }
  }, getRoleAndPerson: {
    url: `${config.API_URL}/lqa-game/system/projectuser/getRoleUser`,
    name: "获取相关角色人员列表",
    get: function (projectNum, language) {
      const params = {
        targetLang: language,
        projectNum: projectNum,
      };
      return http.get(this.url, params);
    }
  }, getAllRoleAndUser: {
    url: `${config.API_URL}/lqa-game/system/projectuser/getAllRoleUser?projectNum=`,
    name: "获取相关角色人员列表",
    get: function (param, param2) {
      return http.get(this.url + param + '&targetLang=' + param2);
    }
  }, reuseUser: {
    url: `${config.API_URL}/lqa-game/system/projectuser/reuse`, name: "获取相关用户信息列表", post: function (data) {
      return http.post(this.url, data);
    }
  }, getProjectOperate: {
    url: `${config.API_URL}/lqa-game/system/project/getProjectOperate`,
    name: "获取相关用户信息列表",
    post: function (data) {
      return http.post(this.url, data);
    }
  }, qa: {
    getQaInfo: {
      url: `${config.API_URL}/lqa-game/system/projectQa/list`, name: "获取问题答案列表", get: function (param) {
        return http.get(this.url, param);
      }
    }, getSearchQaInfo: {
      url: `${config.API_URL}/lqa-game/system/projectQa/qaList`, name: "获取问题答案列表", get: function (param) {
        return http.get(this.url, param);
      }
    },

    updateQaInfo: {
      url: `${config.API_URL}/lqa-game/system/projectQa`, name: "获取问题答案列表", put: async function (data) {
        return await http.put(this.url, data);
      }
    }, newQaInfo: {
      url: `${config.API_URL}/lqa-game/system/projectQa`, name: "获取问题答案列表", post: function (data) {
        return http.post(this.url, data);
      }
    }, getQaInfoById: {
      url: `${config.API_URL}/lqa-game/system/projectQa/`, name: "获取问题答案列表", get: function (param) {
        return http.get(this.url + param);
      }
    }, delQaInfoById: {
      url: `${config.API_URL}/lqa-game/system/projectQa/`, name: "获取问题答案列表", delete: function (param) {
        return http.delete(this.url + param);
      }
    }
  }, invite: {
    user: async function (data) {
      const value = util.trim(data);
      return http.post("/lqa-game/system/emp/add/project/participants", value);
    }
  }, flow: {
    nodes: function (projectNum) {
      return http.get("/lqa-game/project/bugNodeConfig/getDefault", {projectNum});
    }, /**
     * @param nodeId 当前节点ID
     * @param nodes  流转节点集合
     */
    update: function (nodeId, nodes) {
      const list = _.concat([], nodes);
      const data = {id: nodeId, nodes: _.compact(list).join(",")};
      return http.put("/lqa-game/project/bugNodeConfig", data);
    }
  },
  // 附件管理
  attachment: {
    // 添加附件信息
    add (data) {
      return http.post("/lqa-game/system/uploadInfo", data);
    },
    // 查询附件信息
    get (idList) {
      const value = idList.join(",");
      const query = { testId: value };
      return http.get("/lqa-game/system/uploadInfo/getTestCaseFile", query);
    }
  },
}
